import { HelperTableConfig } from 'AppConfig/TableConfig/Helper';

const parseExpression = (input) => {
  const PREFIX = 'Helper.';

  if (!input.startsWith(PREFIX) ) {
    return null;
  }

  const withoutPrefix = input.slice(PREFIX.length);
  const match = withoutPrefix.match(/^([^(]+)\((.*)\)$/);

  if (!match) {
    return null;
  }

  const args = match[2]
    .split(',')
    .map(arg => arg.trim())
    .filter(Boolean);

  return {
    functionPath: match[1],
    args
  };
}

export const getHelper = (value) => {
  if(value === 'false' || value === '0') {
    return false;
  }
  if(value === 'true' || value === '1') {
    return true;
  }
  const parsed = parseExpression(value);
  if(!parsed) {
    return false;
  }
  const path = parsed.functionPath.split('.');

  const func = path.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : null, HelperTableConfig);
  if(typeof func !== 'function') {
    return false;
  }
  return func(parsed.args);

}
